import { render } from "./trainingPriceSummary.vue?vue&type=template&id=40e8432e&scoped=true&ts=true"
import script from "./trainingPriceSummary.vue?vue&type=script&lang=ts"
export * from "./trainingPriceSummary.vue?vue&type=script&lang=ts"

import "./trainingPriceSummary.vue?vue&type=style&index=0&id=40e8432e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e8432e"]])

export default __exports__